import { reservationRepository } from '../../infrastructure/repositories/ReservationRepository';
import type {
  ReservationWithDetails,
  ReservationSource,
  ReservationFilters,
  ReservationsSummary
} from '../../domain/entities/Reservation';

export class ReservationService {
  async getReservationSources(): Promise<ReservationSource[]> {
    return await reservationRepository.getReservationSources();
  }

  async getActiveReservations(filters: ReservationFilters = {}): Promise<ReservationWithDetails[]> {
    return await reservationRepository.getActiveReservations(filters);
  }

  async getReservationsByOrderId(orderId: string): Promise<ReservationWithDetails[]> {
    return await reservationRepository.getReservationsByOrderId(orderId);
  }

  async getReservationsSummary(): Promise<ReservationsSummary> {
    return await reservationRepository.getReservationsSummary();
  }
}

export const reservationService = new ReservationService();

